import type React from 'react';

import { Link } from '@change/ds-core-ui/Link';
import { Text } from '@change/ds-core-ui/Text';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import localWinsPhoto1360 from '#src/app/pages/about/impact/shared/assets/local-pancreatic-cancer-uk-1360w.webp';
import localWinsPhoto680 from '#src/app/pages/about/impact/shared/assets/local-pancreatic-cancer-uk-680w.webp';

/** Max display width ~680px (desktop column); mobile full width. Lets browser pick 1x vs 2x. */
const PHOTO_SIZES = '(max-width: 767px) 100vw, 680px';

export const LocalWins: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();

	return (
		<section className="container grid items-center gap-7 pb-16 md:grid-cols-2 md:gap-18 md:pb-32">
			<div
				className="bg-fill-selected-weaker aspect-[4/3] overflow-hidden rounded-2xl"
				data-qa="impact-local-wins-photo"
			>
				<img
					src={localWinsPhoto680}
					srcSet={`${localWinsPhoto680} 680w, ${localWinsPhoto1360} 1360w`}
					sizes={PHOTO_SIZES}
					alt={translate('corgi.impact_page.local_wins.photo_alt')}
					className="h-full w-full object-cover object-[50%_40%]"
					loading="lazy"
				/>
			</div>
			<div className="flex flex-col items-start gap-5">
				<Text as="h2" variant="heading" size="large" fontWeight="bold">
					<Translate value="corgi.impact_page.local_wins.heading" />
				</Text>
				<Text as="p" variant="body" size="large" className="text-typography-weak">
					<Translate value="corgi.impact_page.local_wins.body" />
				</Text>
				<Link href="/search?status=victory" variant="primary" size="medium" bold>
					<Translate value="corgi.impact_page.local_wins.link" />
				</Link>
			</div>
		</section>
	);
};
